import { c as _c } from "react/compiler-runtime";
import type { LucideIcon } from "lucide-react";
import type { OrganizationMetric } from "../api/organization-metric-drilldown";
export type OrganizationMetricDrilldownTarget = {
  organizationId: string;
  organizationName: string;
  metric: OrganizationMetric;
  expectedCount: number;
  expectedPctLabel: string | null;
};
export function MetricChip(t0) {
  const $ = _c(11);
  const {
    icon: Icon,
    label,
    ariaLabel,
    onClick,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== Icon) {
    t2 = <Icon className="size-3" />;
    $[0] = Icon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label || $[3] !== t2) {
    t3 = <>{t2}{label}</>;
    $[2] = label;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const content = t3;
  if (disabled || !onClick) {
    let t4;
    if ($[5] !== content) {
      t4 = <span className="inline-flex items-center gap-1">{content}</span>;
      $[5] = content;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t4;
  if ($[7] !== ariaLabel || $[8] !== content || $[9] !== onClick) {
    t4 = <button type="button" onClick={onClick} aria-label={ariaLabel} title={ariaLabel} className="hover:text-foreground hover:decoration-primary/60 focus-visible:ring-primary/40 decoration-muted-foreground/40 pointer-events-auto inline-flex items-center gap-1 rounded-sm underline decoration-dotted underline-offset-4 hover:decoration-solid focus-visible:ring-2 focus-visible:outline-none">{content}</button>;
    $[7] = ariaLabel;
    $[8] = content;
    $[9] = onClick;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}